import { compile } from 'formulascript/compiler';
import type { Value, Context } from 'formulascript/interpreter';

import { wrapFunction } from '../utils';

export const EVAL = async (ctx: Context, formula: string): Promise<Value> => {
  const code = compile(formula);

  const result = await ctx.evaluate(code.expr);
  if (result === undefined) {
    throw new Error(
      'The result of the formula is empty, this means you probably made a mistake in your formula',
    );
  }
  return result;
};

export default wrapFunction(EVAL, {
  name: 'EVAL',
  nargs: 1,
  types: ['string'],
  passContext: true,
});
